import request from '@/utils/request'
import { getToken } from '../utils/auth'
// 请求服务列表
export function getservicerecordlist (params, data) {
  params.token = getToken()
  return request({
    url: '/getservicerecordlist',
    method: 'post',
    params,
    data
  })
}
// 请求服务列表 新
export function querypersonsupplierservicerecordsext (params, data) {
  params.token = getToken()
  return request({
    url: '/querypersonsupplierservicerecordsext',
    method: 'post',
    params,
    data
  })
}
// 发起服务
export function createservicerecord (data) {
  return request({
    url: '/createservicerecord',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取文件列表
export function queryfileurl (data) {
  return request({
    url: '/queryfileurl',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/service.js